// src/views/RegisterPage.jsx - CORRIGÉ
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { publicSiteWebService } from "../services/publicSiteWebService";
import Footer from "../components/Footer";
import PublicTopBar from "./PublicTopBar";

export default function RegisterPage() {
  const { registerUser } = useAuth();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    telephone1: "",
    telephone2: "",
    password: "",
    password2: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [checkingParams, setCheckingParams] = useState(true);
  const [inscriptionsOuvertes, setInscriptionsOuvertes] = useState(true);
  const [platformName, setPlatformName] = useState("");

  useEffect(() => {
    publicSiteWebService.getPublicData()
      .then(data => {
        const params = data.parametres || {};
        setInscriptionsOuvertes(params.inscriptions_ouvertes !== false);
        setPlatformName(params.nom_plateforme || "");
      })
      .catch(() => {
        // En cas d'échec, on laisse le formulaire accessible plutôt que de bloquer à tort
        setInscriptionsOuvertes(true);
      })
      .finally(() => setCheckingParams(false));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (error) setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.first_name.trim()) {
      setError("Le prénom est requis.");
      return;
    }
    if (!formData.last_name.trim()) {
      setError("Le nom est requis.");
      return;
    }
    if (!formData.username.trim()) {
      setError("Le nom d'utilisateur est requis.");
      return;
    }
    if (!formData.email.trim()) {
      setError("L'email est requis.");
      return;
    }
    if (!formData.password.trim()) {
      setError("Le mot de passe est requis.");
      return;
    }
    if (!formData.password2.trim()) {
      setError("Veuillez confirmer votre mot de passe.");
      return;
    }

    if (formData.password !== formData.password2) {
      setError("Les mots de passe ne correspondent pas !");
      return;
    }

    if (formData.password.length < 8) {
      setError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }

    setLoading(true);
    try {
      await registerUser({
        first_name: formData.first_name,
        last_name: formData.last_name,
        username: formData.username,
        email: formData.email,
        telephone1: formData.telephone1,
        telephone2: formData.telephone2,
        password: formData.password,
        password2: formData.password2,
      });
    } catch (err) {
      setError(err.response?.data?.message || "Erreur lors de l'inscription. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        :root {
          --n-bg:    #f8f9fa;
          --n-card:  #ffffff;
          --n-ink:   #0f1b2d;
          --n-mut:   #64748b;
          --n-b:     #e8e8ee;
          --n-b2:    #d0d0da;

          --rg-primary:   #004080;
          --rg-primary-h: #003166;
        }

        .rg-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          background: var(--n-bg);
        }

        .rg-section {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 120px 16px 40px;
        }

        .rg-card {
          background: var(--n-card);
          border-radius: 16px;
          padding: 32px 28px;
          width: 100%;
          max-width: 480px;
          box-shadow: 0 1rem 3rem rgba(0,0,0,.12);
          animation: rg-fade-in .6s ease;
        }

        @keyframes rg-fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .rg-title {
          font-weight: 700;
          font-size: 22px;
          color: var(--rg-primary);
          text-align: center;
          margin-bottom: 4px;
        }

        .rg-subtitle {
          font-size: 14px;
          color: var(--n-mut);
          text-align: center;
          margin-bottom: 24px;
        }

        .rg-error {
          background: #fcebeb;
          color: #a32d2d;
          border-radius: 7px;
          padding: 9px 12px;
          font-size: 13px;
          margin-bottom: 16px;
        }

        .rg-closed {
          text-align: center;
          padding: 12px 0 4px;
        }

        .rg-closed-icon {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: rgba(0, 64, 128, 0.08);
          color: var(--rg-primary);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          margin: 0 auto 20px;
        }

        .rg-closed p {
          color: var(--n-mut);
          font-size: 14px;
          line-height: 1.6;
          margin: 0 0 20px;
        }

        .rg-field {
          margin-bottom: 16px;
        }

        .rg-label {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: var(--n-mut);
          margin-bottom: 6px;
        }

        .rg-label .rg-required {
          color: #dc3545;
          margin-left: 2px;
        }

        .rg-label .rg-optional {
          color: var(--n-mut);
          font-weight: 400;
          font-size: 12px;
          margin-left: 4px;
        }

        .rg-input-wrap {
          position: relative;
          display: flex;
        }

        .rg-input {
          width: 100%;
          padding: 10px 14px;
          border: 1px solid var(--n-b2);
          border-radius: 8px;
          font-size: 15px;
          font-family: inherit;
          outline: none;
          box-sizing: border-box;
          color: var(--n-ink);
          background: var(--n-card);
          transition: box-shadow .2s ease;
        }

        .rg-input:focus {
          box-shadow: 0 0 0 0.25rem rgba(0, 64, 128, 0.25);
        }

        .rg-input.pw {
          padding-right: 42px;
          border-radius: 8px;
        }

        .rg-eye {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          color: var(--n-mut);
          font-size: 17px;
          padding: 4px;
          display: flex;
          align-items: center;
        }

        .rg-eye:hover {
          color: var(--n-ink);
        }

        .rg-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }

        .rg-btn {
          width: 100%;
          padding: 12px;
          background: var(--rg-primary);
          color: #fff;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 700;
          font-family: inherit;
          cursor: pointer;
          margin-top: 6px;
          transition: background-color .15s ease, opacity .15s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .rg-btn:hover:not(:disabled) {
          background: var(--rg-primary-h);
        }

        .rg-btn:disabled {
          opacity: .65;
          cursor: default;
        }

        .rg-btn i {
          font-size: 18px;
        }

        .rg-login {
          text-align: center;
          margin-top: 14px;
        }

        .rg-login a {
          color: var(--rg-primary);
          font-size: 13.5px;
          font-weight: 600;
          text-decoration: none;
        }

        .rg-login a:hover {
          text-decoration: underline;
        }

        .rg-login span {
          color: var(--n-mut);
          font-size: 13.5px;
        }

        .rg-links {
          display: flex;
          justify-content: center;
          gap: 16px;
          margin-top: 16px;
          flex-wrap: wrap;
        }

        .rg-links a {
          color: var(--n-mut);
          font-size: 13px;
          text-decoration: none;
          transition: color .2s ease;
        }

        .rg-links a:hover {
          color: var(--rg-primary);
          text-decoration: underline;
        }

        .rg-links .separator {
          color: var(--n-b2);
        }

        @media (max-width: 768px) {
          .rg-section {
            padding: 100px 16px 30px;
          }
        }

        @media (max-width: 480px) {
          .rg-card {
            padding: 24px 18px;
          }
          .rg-title {
            font-size: 20px;
          }
          .rg-section {
            padding: 90px 12px 20px;
          }
          .rg-grid {
            grid-template-columns: 1fr;
            gap: 0;
          }
        }
      `}</style>

      <div className="rg-page">
        <PublicTopBar />

        <div className="rg-section">
          <div className="rg-card">
            {checkingParams ? null : !inscriptionsOuvertes ? (
              <>
                <div className="rg-title">Inscriptions fermées</div>
                <div className="rg-closed">
                  <div className="rg-closed-icon">
                    <i className="ti ti-door-off" />
                  </div>
                  <p>
                    {platformName ? `${platformName} n'accepte` : "Nous n'acceptons"} pas de nouvelles
                    inscriptions pour le moment. Merci de réessayer plus tard ou de nous contacter
                    directement.
                  </p>
                </div>
                <div className="rg-login">
                  <span>Déjà un compte ? </span>
                  <Link to="/login">Se connecter</Link>
                </div>
              </>
            ) : (
              <>
                <div className="rg-title">Créer un compte 👋</div>
                <div className="rg-subtitle">Inscrivez-vous pour suivre la scolarité de votre enfant</div>

                {error && <div className="rg-error">{error}</div>}

                <form onSubmit={handleSubmit} noValidate>
                  <div className="rg-grid">
                    <div className="rg-field">
                      <label className="rg-label">
                        Prénom
                        <span className="rg-required">*</span>
                      </label>
                      <input
                        className="rg-input"
                        type="text"
                        name="first_name"
                        placeholder="Votre prénom"
                        value={formData.first_name}
                        onChange={handleChange}
                        autoComplete="given-name"
                        required
                      />
                    </div>

                    <div className="rg-field">
                      <label className="rg-label">
                        Nom
                        <span className="rg-required">*</span>
                      </label>
                      <input
                        className="rg-input"
                        type="text"
                        name="last_name"
                        placeholder="Votre nom"
                        value={formData.last_name}
                        onChange={handleChange}
                        autoComplete="family-name"
                        required
                      />
                    </div>
                  </div>

                  <div className="rg-field">
                    <label className="rg-label">
                      Nom d'utilisateur
                      <span className="rg-required">*</span>
                    </label>
                    <input
                      className="rg-input"
                      type="text"
                      name="username"
                      placeholder="Choisissez un nom d'utilisateur"
                      value={formData.username}
                      onChange={handleChange}
                      autoComplete="username"
                      required
                    />
                  </div>

                  <div className="rg-field">
                    <label className="rg-label">
                      Email
                      <span className="rg-required">*</span>
                    </label>
                    <input
                      className="rg-input"
                      type="email"
                      name="email"
                      placeholder="exemple@email.com"
                      value={formData.email}
                      onChange={handleChange}
                      autoComplete="email"
                      required
                    />
                  </div>

                  <div className="rg-field">
                    <label className="rg-label">
                      Téléphone principal
                      <span className="rg-optional">(optionnel)</span>
                    </label>
                    <input
                      className="rg-input"
                      type="tel"
                      name="telephone1"
                      placeholder="+226 05 00 00 00 00"
                      value={formData.telephone1}
                      onChange={handleChange}
                      autoComplete="tel"
                    />
                  </div>

                  <div className="rg-field">
                    <label className="rg-label">
                      Téléphone secondaire
                      <span className="rg-optional">(optionnel)</span>
                    </label>
                    <input
                      className="rg-input"
                      type="tel"
                      name="telephone2"
                      placeholder="+226 05 00 00 00 00"
                      value={formData.telephone2}
                      onChange={handleChange}
                      autoComplete="tel"
                    />
                  </div>

                  <div className="rg-field">
                    <label className="rg-label">
                      Mot de passe
                      <span className="rg-required">*</span>
                    </label>
                    <div className="rg-input-wrap">
                      <input
                        className="rg-input pw"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Minimum 8 caractères"
                        value={formData.password}
                        onChange={handleChange}
                        autoComplete="new-password"
                        required
                      />
                      <button
                        type="button"
                        className="rg-eye"
                        onClick={() => setShowPassword((v) => !v)}
                        aria-label={
                          showPassword
                            ? "Masquer le mot de passe"
                            : "Afficher le mot de passe"
                        }
                      >
                        <i
                          className={`ti ${showPassword ? "ti-eye-off" : "ti-eye"}`}
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </div>

                  <div className="rg-field">
                    <label className="rg-label">
                      Confirmer le mot de passe
                      <span className="rg-required">*</span>
                    </label>
                    <input
                      className="rg-input"
                      type={showPassword ? "text" : "password"}
                      name="password2"
                      placeholder="Confirmez votre mot de passe"
                      value={formData.password2}
                      onChange={handleChange}
                      autoComplete="new-password"
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="rg-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <i className="ti ti-loader" style={{ animation: "spin 1s linear infinite" }} />
                        Inscription...
                      </>
                    ) : (
                      <>
                        <i className="ti ti-user-plus" />
                        S'inscrire
                      </>
                    )}
                  </button>
                </form>

                <div className="rg-login">
                  <span>Déjà un compte ? </span>
                  <Link to="/login">Se connecter</Link>
                </div>
              </>
            )}
          </div>
        </div>

        <Footer />
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}